import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import InputMoney from '../../components/InputMoney';
import FormButtons from '../../components/FormButtons';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';
import { DescriptionForm } from '../../components/styled';

interface BseIncomeProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

const BseIncome = (props: BseIncomeProps) => {
  const { idRequest, next, save } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formIncome } = formatValuesLoad(formBse?.data);
  const {
    fields,
    setFieldValue,
    setFieldError,
    formIsValid,
    formIsComplete,
    formIsEmpty
  } = useFields(formIncome || {});
  if (!formBse?.data) return null;

  const {
    incomeDelEstudiante,
    incomeDePadre,
    incomeDeMadre,
    incomeDeApoderado,
    incomeDeOtroFamiliar,
    incomeDeConyugue,
    incomeRentas,
    incomeRemesas,
    incomeOtros
  } = fields;

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('income', fields, formIsComplete, true);
  };

  const getProps = () => ({
    setFieldError,
    setFieldValue,
    validateOnStart: idRequest ? idRequest > 0 && !formIsEmpty : false,
    validateForm: formIsEmpty || idRequest === 0 ? 0 : idRequest
  });
  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('income', fields, formIsComplete, false);
    }
  }, [idRequest, formIsEmpty]);
  return (
    <div data-testid="cmp-bse-form-income" style={{ padding: '16px 24px' }}>
      <DescriptionForm style={{ color: '#5b36f2' }}>
        Registra los ingresos mensuales propios o de tu familia que aplique,
        caso contrario colocar &quot;0&quot;
      </DescriptionForm>
      <InputMoney
        nameLabel="Del estudiante"
        value={incomeDelEstudiante}
        name="incomeDelEstudiante"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Del padre"
        value={incomeDePadre}
        name="incomeDePadre"
        {...getProps()}
      />
      <InputMoney
        nameLabel="De la madre"
        value={incomeDeMadre}
        name="incomeDeMadre"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Del apoderado"
        value={incomeDeApoderado}
        name="incomeDeApoderado"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Otro familiar"
        value={incomeDeOtroFamiliar}
        name="incomeDeOtroFamiliar"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Del cónyugue"
        value={incomeDeConyugue}
        name="incomeDeConyugue"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Rentas y alquileres"
        value={incomeRentas}
        name="incomeRentas"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Remesas"
        value={incomeRemesas}
        name="incomeRemesas"
        {...getProps()}
      />
      <InputMoney
        nameLabel="Otros"
        value={incomeOtros}
        name="incomeOtros"
        {...getProps()}
      />

      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        formIsValid={formIsValid}
      />
    </div>
  );
};

export default BseIncome;
